const Functions = {
	changeQuantity(line, quantity){
		fetch('/cart/change.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ quantity: quantity, line: line })
		})
		.then(response => response.json())
		.then(data => {
			window.dispatchEvent(new CustomEvent('update-cart', { detail: data }))
		})
		.catch(errror => console.error('Error:', error));
	},
	addToCart(form){
		let formData = new FormData(form);
		fetch('/cart/add.js', {
				method: 'POST',
				body: formData
			})
			.then(response => {
				return response.json();
			})
			.then(response => {
				window.dispatchEvent(new CustomEvent('update-cart'))
				window.dispatchEvent(new CustomEvent('toggle-cart'))
                window.dispatchEvent(new CustomEvent("add-to-cart", {detail: response}));
				// document.body.classList.add('overflow-hidden')
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	}
}

window.Functions = Functions

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.anchor-button').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault(); 
      const bundlesSection = document.querySelector('.products-grid'); 
      if (bundlesSection) {
        const bundlesTop = bundlesSection.getBoundingClientRect().top + window.pageYOffset + 80; 
        window.scrollTo({
          top: bundlesTop,
          behavior: 'smooth'
        });
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const galleryProduct1 = () => {
    var galleryTop = new Swiper(".gallery-top-new-pdp", {
      spaceBetween: 10,
      navigation: {
        nextEl: ".product-gallery-next",
        prevEl: ".product-gallery-prev",
      },
    });

    const thumbs = document.querySelectorAll(".thumb-item");
    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", function () {
        const index = parseInt(this.getAttribute("data-index"), 10);
        galleryTop.slideTo(index);
      });
    });
  };

  document.addEventListener("shopify:section:load", galleryProduct1);

  galleryProduct1();
});


window.addEventListener("add-to-cart", (e) => {
  console.log(e.detail)
  const payload = {
    product_title: e.detail?.product_title,
    each_price: e.detail?.presentment_price,
    total_price: (e.detail?.line_price || 0) / 100,
    quantity: e.detail?.quantity,
    variant_title: e.detail?.variant_title,
    product_id: e.detail?.product_id,
    variant_id: e.detail?.variant_id,
    sku: e.detail?.sku,
    vendor: e.detail?.vendor
  }
  mixpanel.track("add_to_cart", payload);
})

const iconClose = `<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.25 1.75L1.75 6.25" stroke="#333333" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.25 6.25L1.75 1.75" stroke="#333333" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const USER_ID = 'a0d3a4a0-0cfc-402c-b32b-4ffbe6a7cf58'

document.addEventListener("DOMContentLoaded", () => {
  class ProductReviewTooltip extends HTMLElement {
    constructor() {
      super();
    }

    async getDataReviews() {
      const productId = this.getAttribute("data-product-id")
      if (!productId) return

      const URL = `https://api.okendo.io/v1/stores/${USER_ID}/products/shopify-${productId}/reviews?limit=8&locale=nl`
      const response = await fetch(URL)
      const data = await response.json()
      let html = ''

      if (data?.reviews) {
        data.reviews.forEach(review => {
          const shortName = review.reviewer.displayName
          .split(' ')
          .map(word => word.charAt(0))
          .join('');

          html += `
            <li>
              <div class="prt__slider-item">
                <div class="prt__slider-item__header">
                  <div class="prt__slider-item__header__left">
                    <div class="prt__slider-item__header__short__name">${shortName}</div>
                  </div>
                  <div class="prt__slider-item__header__right">
                    <div class="prt__slider-item__header__name">${review.reviewer.displayName}</div>
                    ${review.reviewer.isVerified ? '<div class="prt__slider-item__header__right__verified">Verified Buyer</div>' : ''}
                  </div>
                  ${review.productImageUrl ? `<div class="prt__slider-item__header__image" style="background-image: url(${review.productImageUrl})"></div>` : ''}
                </div>
                <div class="prt__slider-item__content">
                  ${review.body}
                </div>
              </div>
            </li> `
        }) 
      }

      return html
    }

    async init() {
      const header = document.querySelector('.oke-w-header-content-block--left')
      const reviews = await this.getDataReviews()

      if (!header || !reviews) return

      const newHeader = header.innerHTML.replaceAll("oke-star-filled", "icon-star-filled").replace('Gebaseerd op', 'Based on').replace('beoordelingen', 'reviews')

      let html = `
        <div class="prt__container">
          <div class="prt__arrow"></div>
          <div class="prt__header">
            ${newHeader}
            <div class="prt__close js-tooltip-trigger">
              ${iconClose}
            </div>
          </div>
          <div class="prt__slider">
            <ul class="prt__slider__container">${reviews}</ul>
          </div>
        </div>
        `
      this.innerHTML = html

      this.triggerTooltip()

      jQuery('.prt__slider__container').slick({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      });   
    }

    triggerTooltip() {
      const btns = document.querySelectorAll('.js-tooltip-trigger')
      btns.forEach(btn => {
        btn.addEventListener('click', () => {
          const tooltip = document.querySelector('.js-tooltip-container')
          if (tooltip.classList.contains('open')) { 
            tooltip.classList.remove('open')
          } else {
            tooltip.classList.add('open')
          }
        })
      })
    }
  
    connectedCallback() {
      this.init()
    }
  }
  
  customElements.define("product-review-tooltip", ProductReviewTooltip);
});

/* Product Review Tooltip */
jQuery(document).ready(function () {
  jQuery('.product__review__tooltip .review-slider').slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  });

  jQuery('.js-review-tooltip-close').click(() => {
    jQuery('.product__review__tooltip').addClass('hidden');
  });

  jQuery('.js-show-tooltip').click(() => {
    if (jQuery('.product__review__tooltip').hasClass('hidden')) {
      jQuery('.product__review__tooltip').removeClass('hidden');
      return 
    }

    jQuery('.product__review__tooltip').addClass('hidden');
  });
});
